import { createVanIconComponent } from "./van"

const Info = createVanIconComponent("info")
export default Info
